import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faAngleLeft, fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { putData } from "../../../utils/api";
import Table from "react-bootstrap/Table";
import { useNavigate, useParams } from "react-router";
import Header from "../../Header/Header";
library.add(fas);

const EditOffCanvance = (props) => {
  const navigate = useNavigate();

  // const id = props.show;
  const { id } = useParams();
  const { postData, getData, IMG_URL } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });
  const [data, setData] = useState({});
  const GetEditData = async () => {
    const response = await getData(`/admin/customer/${id}`);
    setData(response?.data);
  };
  useEffect(() => {
    GetEditData();
  }, []);

  const formatTimeInIST = (date) => {
    const createdAt = new Date(date);
    const options = { hour: "2-digit", minute: "2-digit", hour12: true };
    const istTime = createdAt.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      ...options,
    });
    // setFormattedTime(`${istTime} IST`);
    return istTime;
  };

  const calculateTimeAgo = (date) => {
    const createdAt = new Date(date);
    const now = new Date();
    const diffInMilliseconds = now - createdAt;

    const diffInMinutes = Math.floor(diffInMilliseconds / 60000);
    const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));

    if (diffInDays >= 1) {
      return `${diffInDays} Day${diffInDays > 1 ? "s" : ""} Ago`;
    } else if (diffInHours >= 1) {
      return `${diffInHours} Hour${diffInHours > 1 ? "s" : ""} Ago`;
    } else {
      return `${diffInMinutes} Min Ago`;
    }
  };

  const calculateTotalAmount = () => {
    return data?.customer_orders
      ?.reduce((total, order) => {
        return total + parseFloat(order?.total_amount || 0);
      }, 0)
      .toFixed(2);
  };

  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  return (
    <>
      <Header title={"Customer Order List"} link={"#"} />
      <section className="Create">
        <div className="back_btn_holder">
          <div onClick={() => navigate(`/customers`)}>
            <FontAwesomeIcon className="back-btn" icon={faAngleLeft} />
            Back
          </div>
        </div>

        <Modal.Body>
          <div
            className="p-4 mb-4"
            style={{
              background: "#fff",
              borderRadius: "16px",
              boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
              border: "1px solid #edf2f7",
            }}
          >
            <div className="d-flex align-items-center justify-content-between mb-4">
              <h4
                style={{
                  margin: 0,
                  fontWeight: 700,
                  color: "#1a202c",
                }}
              >
                User Details
              </h4>
            </div>

            <div className="row g-4">
              {/* Profile Image */}
              <div className="col-md-3 text-center">
                {data?.image ? (
                  <div
                    onClick={() => {
                      setSelectedImage(data.image);
                      setShowImageModal(true);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src={IMG_URL + data.image}
                      alt="Profile"
                      className="img-fluid"
                      style={{
                        width: "180px",
                        height: "180px",
                        objectFit: "cover",
                        borderRadius: "50%",
                        border: "4px solid #edf2f7",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                      }}
                    />
                    <div className="mt-3">
                      <h6 className="mb-0">{data?.name || "-"}</h6>
                      <small className="text-muted">
                        {data?.contact_no || "-"}
                      </small>
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      width: "180px",
                      height: "180px",
                      borderRadius: "50%",
                      background: "#f7fafc",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto",
                    }}
                  >
                    No Image
                  </div>
                )}
              </div>

              {/* User Information */}
              <div className="col-md-9">
                <div className="row">
                  {data?.email && (
                    <div className="col-md-6 mb-3">
                      <label className="text-muted small">Email</label>

                      <div className="fw-semibold">{data?.email || "-"}</div>
                    </div>
                  )}
                  {data?.contact_no && (
                    <div className="col-md-6 mb-3">
                      <label className="text-muted small">Mobile Number</label>
                      <div className="fw-semibold">
                        {data?.contact_no || "-"}
                      </div>
                    </div>
                  )}
                  {data?.upi_id && (
                    <div className="col-md-6 mb-3">
                      <label className="text-muted small">UPI ID</label>
                      <div className="fw-semibold">{data?.upi_id || "-"}</div>
                    </div>
                  )}
                  {data?.pan_number && (
                    <div className="col-md-6 mb-3">
                      <label className="text-muted small">PAN Number</label>
                      <div className="fw-semibold">
                        {data?.pan_number || "-"}
                      </div>
                    </div>
                  )}
                  {data?.adhar_number && (
                    <div className="col-md-6 mb-3">
                      <label className="text-muted small">Aadhar Number</label>
                      <div className="fw-semibold">
                        {data?.adhar_number || "-"}
                      </div>
                    </div>
                  )}
                  {data?.affiliate_card && (
                    <div className="col-md-6 mb-3">
                      <label className="text-muted small">
                        {" "}
                        <Button
                          className="action-btn active"
                          onClick={() => {
                            if (data?.affiliate_card) {
                              window.open(
                                IMG_URL + data?.affiliate_card,
                                "_blank",
                                "noopener,noreferrer",
                              );
                            }
                          }}
                        >
                          View Card
                        </Button>
                      </label>

                      <div className="fw-semibold"></div>
                    </div>
                  )}
                </div>

                <hr />
                {/* {data?.Bank_Detail?.account_no && (
                  <h5
                    style={{
                      fontWeight: 600,
                      color: "#2d3748",
                      marginBottom: "20px",
                    }}
                  >
                    Bank Details
                  </h5>
                )} */}

                {/* <div className="row">
                  {data?.Bank_Detail?.account_no && (
                    <div className="col-md-6 mb-3">
                      <label className="text-muted small">Account Number</label>
                      <div className="fw-semibold">
                        {data?.Bank_Detail?.account_no}
                      </div>
                    </div>
                  )}
                  {data?.Bank_Detail?.account_holder_name && (
                    <div className="col-md-6 mb-3">
                      <label className="text-muted small">
                        Account Holder Name
                      </label>
                      <div className="fw-semibold">
                        {data?.Bank_Detail?.account_holder_name}
                      </div>
                    </div>
                  )}
                  {data?.Bank_Detail?.ifsc && (
                    <div className="col-md-6 mb-3">
                      <label className="text-muted small">IFSC Code</label>
                      <div className="fw-semibold">
                        {data?.Bank_Detail?.ifsc}
                      </div>
                    </div>
                  )}
                  {data?.Bank_Detail?.branch_name && (
                    <div className="col-md-6 mb-3">
                      <label className="text-muted small">Branch Name</label>
                      <div className="fw-semibold">
                        {data?.Bank_Detail?.branch_name}
                      </div>
                    </div>
                  )}
                  {data?.Bank_Detail?.nominee_name && (
                    <div className="col-md-6 mb-3">
                      <label className="text-muted small">Nominee Name</label>
                      <div className="fw-semibold">
                        {data?.Bank_Detail?.nominee_name}
                      </div>
                    </div>
                  )}
                  {data?.Bank_Detail?.nominee_number && (
                    <div className="col-md-6 mb-3">
                      <label className="text-muted small">
                        Nominee Mobile Number
                      </label>
                      <div className="fw-semibold">
                        {data?.Bank_Detail?.nominee_number}
                      </div>
                    </div>
                  )}
                  {data?.Bank_Detail?.nominee_relation && (
                    <div className="col-md-6 mb-3">
                      <label className="text-muted small">
                        Nominee Relation
                      </label>
                      <div className="fw-semibold">
                        {data?.Bank_Detail?.nominee_relation}
                      </div>
                    </div>
                  )}
                  {data?.Bank_Detail?.nominee_adhar_number && (
                    <div className="col-md-6 mb-3">
                      <label className="text-muted small">
                        Nominee Aadhar Number
                      </label>
                      <div className="fw-semibold">
                        {data?.Bank_Detail?.nominee_adhar_number}
                      </div>
                    </div>
                  )}
                </div> */}
              </div>
            </div>
          </div>
          <div className="total-amount">
            Total Spent: <strong>{calculateTotalAmount()}</strong>
          </div>

          <div className="row mt-3">
            <div className="data table-responsive">
              <Table striped bordered hover responsive center>
                <thead>
                  <tr className="">
                    <th className="sr" style={{ width: "10%" }}>
                      Sr. No.
                    </th>

                    <th className="tax-name" style={{ width: "10%" }}>
                      Order Date
                    </th>

                    <th className="tax-name" style={{ width: "10%" }}>
                      Invoice
                    </th>

                    <th className="tax-name" style={{ width: "10%" }}>
                      Products
                    </th>

                    <th className="tax-name" style={{ width: "10%" }}>
                      Amount
                    </th>

                    <th className="tax-name" style={{ width: "10%" }}>
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data?.customer_orders?.length > 0 ? (
                    data?.customer_orders?.map((d, index) => {
                      return (
                        <tr className="" key={index}>
                          <td>{++index}.</td>
                          <td>
                            <div>{calculateTimeAgo(d?.createdAt)}</div>
                            <div>{formatTimeInIST(d?.createdAt)}</div>
                          </td>
                          <td>{d?.invoice_no}</td>
                          <td>
                            {d?.Product_Order_Details?.map((item, index) => (
                              <div key={index}>{item?.Product?.name}</div>
                            ))}
                          </td>

                          <td>{parseFloat(d?.total_amount).toFixed(2)}</td>
                          <td>{d?.Order_status?.name}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={99} className="text-center">
                        Sorry, No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        </Modal.Body>
      </section>
      <Modal
        show={showImageModal}
        onHide={() => setShowImageModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton />

        <Modal.Body className="text-center p-2">
          <img
            src={IMG_URL + selectedImage}
            alt="Preview"
            style={{
              width: "100%",
              maxHeight: "80vh",
              objectFit: "contain",
            }}
          />
        </Modal.Body>
      </Modal>
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
